import { render, staticRenderFns } from "./SchedulePage.vue?vue&type=template&id=0bd71fc2&scoped=true"
import script from "./SchedulePage.vue?vue&type=script&lang=js"
export * from "./SchedulePage.vue?vue&type=script&lang=js"
import style0 from "./SchedulePage.vue?vue&type=style&index=0&id=0bd71fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd71fc2",
  null
  
)

export default component.exports